import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { TranslationService } from "@proximus/ng-common";

@Injectable({
  providedIn: 'root'
})
export class IntentActivatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private translateService: TranslationService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean  {
    const category = route.paramMap.get('category');
    if(category && this.translateService.getTranslatedValueFor('products.overview.isDynamicCtaActivatedFeatureFlag') === 'false') {
      this.router.navigate(['/overview']);
      return false;
    } else if(this.translateService.getTranslatedValueFor('products.addProduct.eshare.enable') === 'true') {
      const url = this.translateService.getTranslatedValueFor('products.addProduct.eshare.url');
      if(!url) {
        this.router.navigate(['/overview']);
        return false;
      }
    }
    return true;
  }

}
